import sliderSettings from './sliderSettings'

export default sliderSettings
